var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContPhoneIc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.27458 7.02753L5.03486 5.26725C5.39394 4.90818 5.51819 4.37761 5.37296 3.89101C5.2594 3.51051 5.13146 3.05309 5.04641 2.66195C4.96775 2.30018 4.6503 2 4.28008 2H3.27458C2.53414 2 1.92608 2.60256 2.0073 3.33853C2.62473 8.93307 7.06694 13.3753 12.6615 13.9927C13.3975 14.0739 14 13.4659 14 12.7254V11.7199C14 11.3497 13.6986 11.046 13.3343 10.9797C12.9325 10.9067 12.5074 10.7869 12.1517 10.6735C11.6407 10.5106 11.0727 10.6251 10.6935 11.0043L8.97247 12.7254",
    stroke: "#8790A1",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContPhoneIc);
export default __webpack_public_path__ + "static/media/cont_phone_ic.37e63ee28265ec1574898b0bd102c004.svg";
export { ForwardRef as ReactComponent };